module.exports = __webpack_public_path__ + "img/9791185871622.6fa567fe.jpg";